
export default function(state=null,action){
    switch (action.type) {
      case "HOLD_REASONS":
          return action.payload;
      default: return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/reducer/get_hold_reasons.js